import styled from "styled-components";

const RoadmapCss = styled.div`
  background-color: #0a171a;
  .wrapper {
    padding: 0 0 5rem 0;
    @media (max-width: 1700px) {
      padding: 0 0 1rem 0;
    }
    .title {
      transform: translateX(-100%);
      transition: 2s ease;
      padding-top: 2em;
      margin-bottom: -3rem;

      // @media (max-width: 1700px) {
      //   margin-bottom: -4rem;
      // }
      color: white;
      font-family: Poppins;
      font-size: 40px;
      font-style: normal;
      font-weight: 300;
      line-height: 60px;
      letter-spacing: 0em;
      text-align: center;
      &.fadeIn {
        transform: translateX(0%);
        opacity: 1;
      }
      @media (max-width: 1700px) {
        font-size: 35px;
        // padding-bottom: 0;
      }
      @media (max-width: 800px) {
        font-size: 32px;
        padding-bottom: 2rem;
        margin-bottom: 1rem;
      }
      @media (max-width: 600px) {
        font-size: 26px;
        padding-bottom: 2rem;
        margin-bottom: 0rem;
      }
      @media (max-width: 400px) {
        font-size: 24px;
        padding-bottom: 2rem;
      }
    }
    .top {
      display: block;
      @media (max-width: 800px) {
        display: none;
        position: static;
      }
      position: relative;
      .q2 {
        position: absolute;
        left: 10.4%;
        padding: 3rem;
        @media (max-width: 1700px) {
          top: 4rem;
          left: 9.4%;
        }
        transition: transform 1s;
        &:hover {
          transform: scale(1.1);
        }
        .q_title {
          font-family: Poppins;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 42px;
          letter-spacing: 0em;
          text-align: left;
          color: #fdcd0b;
          @media (max-width: 1700px) {
            font-size: 22px;
            line-height: 25px;
          }
        }
        .q_text {
          color: white;
          margin-top: 2rem;
          padding-left: 2rem;
          font-family: Poppins;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: left;
          border-left: 2px solid rgba(253, 205, 11, 0.3);
          @media (max-width: 1700px) {
            font-size: 15px;
            line-height: 25px;
          }
        }
      }
      .q4 {
        position: absolute;
        left: 55.2%;
        top: 5rem;
        padding: 3rem;
        transition: transform 1s;
        &:hover {
          transform: scale(1.1);
        }
        @media (max-width: 1700px) {
          top: 8rem;
          left: 54.2%;
        }
        .q_title {
          font-family: Poppins;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 42px;
          letter-spacing: 0em;
          text-align: left;
          color: #fdcd0b;
          @media (max-width: 1700px) {
            font-size: 22px;
            line-height: 25px;
          }
        }
        .q_text {
          color: white;
          margin-top: 2rem;
          padding-left: 2rem;
          font-family: Poppins;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: left;
          border-left: 2px solid rgba(253, 205, 11, 0.3);
          ul {
            //   margin-left: 1rem;
          }
          @media (max-width: 1700px) {
            font-size: 15px;
            line-height: 25px;
          }
        }
      }
    }
    .middle {
      position: relative;
      height: 3px;
      background-color: rgba(33, 81, 89, 1);
      width: 100vw;
      margin-top: 22rem;
      margin-bottom: 22rem;
      display: block;
      @media (max-width: 800px) {
        display: none;
        position: static;
      }
      .c1 {
        position: absolute;
        left: 12.1%;
        top: -1rem;
      }
      .c2 {
        position: absolute;
        left: 34.1%;
        top: -1rem;
      }
      .c3 {
        position: absolute;
        left: 57%;
        top: -1rem;
      }
      .c4 {
        position: absolute;
        left: 78.8%;
        top: -1rem;
      }
    }
    .bottom {
      display: block;
      @media (max-width: 800px) {
        display: none;
        position: static;
      }
      position: relative;
      .q3 {
        position: absolute;
        left: 32.1%;
        width: 34rem;
        margin-top: -22rem;
        padding: 3rem;
        transition: transform 1s;
        &:hover {
          transform: scale(1.1);
        }
        @media (max-width: 980px) {
          width: 24rem;
        }
        .q_title {
          font-family: Poppins;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 42px;
          letter-spacing: 0em;
          text-align: left;
          color: #fdcd0b;
          @media (max-width: 1700px) {
            font-size: 22px;
            line-height: 25px;
          }
        }
        .q_text {
          color: white;
          margin-top: 2rem;
          padding-left: 2rem;
          font-family: Poppins;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: left;
          border-left: 2px solid rgba(253, 205, 11, 0.3);
          ul {
            //   margin-left: 1rem;
          }
          @media (max-width: 1700px) {
            font-size: 15px;
            line-height: 30px;
          }
        }
      }
      .q1 {
        position: absolute;
        margin-top: -22rem;
        left: 74.9%;
        padding: 3rem;
        padding-right: 0;
        transition: transform 1s;
        &:hover {
          transform: scale(1.1);
        }
        @media (max-width: 980px) {
          width: 12rem;
        }
        .q_title {
          font-family: Poppins;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 42px;
          letter-spacing: 0em;
          text-align: left;
          color: #fdcd0b;
          @media (max-width: 1700px) {
            font-size: 22px;
            line-height: 25px;
          }
        }
        .q_text {
          color: white;
          margin-top: 2rem;
          padding-left: 1rem;
          font-family: Poppins;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: 40px;
          letter-spacing: 0em;
          text-align: left;
          border-left: 2px solid rgba(253, 205, 11, 0.3);
          ul {
            //   margin-left: 1rem;
          }
          @media (max-width: 1700px) {
            font-size: 15px;
            line-height: 30px;
          }
        }
      }
    }
    .tab_view {
      display: none;
      @media (max-width: 800px) {
        display: flex;
      }
      @media (max-width: 600px) {
        display: none;
      }
      .left {
        .q3 {
          position: absolute;
          right: 50%;
          text-align: right;
          padding-right: 2rem;
          margin-top: 25vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            padding-right: 1rem;
            font-family: Poppins;
            font-size: 25px;
            font-style: normal;
            font-weight: 400;
            line-height: 35px;
            letter-spacing: 0em;
            text-align: right;
            color: #fdcd0b;
            @media (max-width: 600px) {
              font-size: 22px;
              line-height: 25px;
            }
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-right: 1rem;
            font-family: Poppins;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: 25px;
            letter-spacing: 0em;
            text-align: right;
          }
        }
        .q1 {
          position: absolute;
          right: 50%;
          text-align: right;
          padding-right: 2rem;
          margin-top: 75vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            padding-right: 1rem;
            font-family: Poppins;
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 42px;
            letter-spacing: 0em;
            text-align: right;
            color: #fdcd0b;
            @media (max-width: 600px) {
              font-size: 22px;
              line-height: 25px;
            }
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-right: 1rem;
            font-family: Poppins;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: 25px;
            letter-spacing: 0em;
            text-align: right;
          }
        }
      }

      .middle_section {
        margin-left: auto;
        margin-right: auto;
        height: 100vh;
        width: 2px;
        // positio: relative;
        overflow-x: visible;
        background-color: rgba(33, 81, 89, 1);
        .c11 {
          position: absolute;
          width: 20px;
          left: 48.5%;
          @media (max-width: 400px) {
            left: 47.8%;
          }
        }
        .c22 {
          position: absolute;
          width: 20px;
          left: 48.5%;
          @media (max-width: 400px) {
            left: 47.8%;
          }
          margin-top: 25vh;
        }
        .c33 {
          position: absolute;
          width: 20px;
          left: 48.5%;
          @media (max-width: 400px) {
            left: 47.8%;
          }
          margin-top: 50vh;
        }
        .c44 {
          position: absolute;
          width: 20px;
          left: 48.5%;
          @media (max-width: 400px) {
            left: 47.8%;
          }
          margin-top: 75vh;
        }
      }
      .right {
        .q2 {
          position: absolute;
          left: 50%;
          padding-left: 2rem;
          margin-top: 0vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            font-family: Poppins;
            font-size: 25px;
            padding-left: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 35px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
            @media (max-width: 600px) {
              font-size: 22px;
              line-height: 25px;
            }
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: 25px;
            letter-spacing: 0em;
            text-align: left;
          }
        }
        .q4 {
          position: absolute;
          left: 50%;
          padding-left: 2rem;
          margin-top: 49vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 42px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
            @media (max-width: 600px) {
              font-size: 22px;
              line-height: 25px;
            }
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: 25px;
            letter-spacing: 0em;
            text-align: left;
          }
        }
      }
    }
    .mobile_view {
      display: none;
      @media (max-width: 600px) {
        display: flex;
      }
      .timeline {
        // flex: 0.25;
        height: 80vh;
        width: 3px;
        margin-left: 15%;
        margin-right: auto;
        background-color: rgba(33, 81, 89, 1);
        .c111 {
          position: absolute;
          width: 20px;
          left: 13.2%;
        }
        .c222 {
          position: absolute;
          width: 20px;
          left: 13.2%;
          margin-top: 21vh;
        }
        .c333 {
          position: absolute;
          width: 20px;
          left: 13.2%;
          margin-top: 55vh;
        }
        .c444 {
          position: absolute;
          width: 20px;
          left: 13.2%;
          margin-top: 71vh;
        }
      }
      .right {
        .q2 {
          position: absolute;
          left: 14%;
          padding-left: 2rem;
          margin-top: 0vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            font-family: Poppins;
            font-size: 22px;
            padding-left: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            @media (max-width: 400px) {
              font-size: 11px;
              line-height: 16px;
            }
          }
        }

        .q3 {
          position: absolute;
          left: 14%;
          padding-left: 2rem;
          margin-top: 20vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            font-family: Poppins;
            font-size: 22px;
            padding-left: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            @media (max-width: 400px) {
              font-size: 11px;
              line-height: 16px;
            }
          }
        }

        .q4 {
          position: absolute;
          left: 14%;
          padding-left: 2rem;
          margin-top: 55vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            font-family: Poppins;
            font-size: 22px;
            padding-left: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            @media (max-width: 400px) {
              font-size: 11px;
              line-height: 16px;
            }
          }
        }
        .q1 {
          position: absolute;
          left: 14%;
          text-align: left;
          padding-left: 2rem;
          margin-top: 70vh;
          transition: transform 1s;
          &:hover {
            transform: scale(1.1);
          }
          .q_title {
            font-family: Poppins;
            font-size: 22px;
            padding-left: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
            color: #fdcd0b;
          }
          .q_text {
            color: white;
            margin-top: 1rem;
            padding-left: 1rem;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            @media (max-width: 400px) {
              font-size: 11px;
              line-height: 16px;
            }
          }
        }
      }
    }
  }
`;

export default RoadmapCss;
